import React, { useEffect, useState, SyntheticEvent } from 'react'
import Link from 'next/link'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import get from 'lodash/get'
import SeriesDetailLink from 'Components/links/series-detail'
import applyHttpsImage from 'lib/apply-https-img'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Pagination } from 'swiper'
SwiperCore.use([Navigation, Pagination])

interface CarAtlasProps {
  seriesList: SeriesData[]
  panoramicCar: {
    ns_cover_url: string
    panoramic_url: string
    series_name: string
  }
}

export interface SeriesData {
  series_id: number
  series_name: string
  cover_url: string
}

// TODO 更换图集页的入口
export default function CarAtlas({
  seriesList = [],
  panoramicCar,
}: CarAtlasProps) {
  const FRAME_TIMES = 3
  const params = {
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    loop: true,
    spaceBetween: 30,
    on: {
      slideChangeTransitionStart() {
        // TODO 添加埋点
        const activeIndex =
          (get(this, 'activeIndex', 1) - 1 + FRAME_TIMES) % FRAME_TIMES
        sendTeaCommEvent('show_excellent_car_picture_card', {
          rank: activeIndex,
        })
      },
    },
  }

  return (
    <>
      <div className="card-wrapper" id="featured_images">
        <section
          className="car-atlas"
          onClick={(e: SyntheticEvent) => {
            const target = e.target as HTMLElement
            const prevPressed = target.classList.contains('swiper-button-prev')
            const nextPressed = target.classList.contains('swiper-button-next')
            if (prevPressed || nextPressed) {
              sendTeaCommEvent('click_excellent_car_picture_switch', {
                switch_direction: nextPressed ? 'right' : 'left',
              })
              return
            }
          }}
        >
          <div className="header">
            <div className="title fl">精美车图</div>
            {/* <div className="fr">
              <Link href="/video/home" as={'/video'}>
                <a
                  target="_blank"
                  className="more"
                  onClick={() => {
                    sendTeaCommEvent('click_selected_carimage_channel_entry')
                  }}
                >
                  更多图片
                  <i className="more-icon icon-arrow-ic-r" />
                </a>
              </Link>
            </div> */}
          </div>

          <Swiper
            navigation={{
              nextEl: '.atlas-nav-next',
              prevEl: '.atlas-nav-pre',
            }}
            spaceBetween={16}
            watchOverflow={true}
            slidesPerView={1}
            slidesPerGroup={1}
            preventClicks={false}
            allowTouchMove={false}
            loop={true}
            className={'tw-w-full swiper-atlas-class'}
            pagination={{
              el: '.banner-swiper-pagination',
              type: 'bullets',
              bulletActiveClass: 'banner-active-bullet',
              bulletClass: 'banner-bullet',
              clickable: true,
            }}
            onSlideChangeTransitionStart={swiper => {
              const activeIndex =
                (get(swiper, 'activeIndex', 1) - 1 + FRAME_TIMES) % FRAME_TIMES
              sendTeaCommEvent('show_excellent_car_picture_card', {
                rank: activeIndex,
              })
            }}
          >
            {new Array(FRAME_TIMES)
              .fill(undefined)
              .map((item: number, index: number) => {
                const currentIndex = index * 5
                const currectList = seriesList.slice(
                  currentIndex + 1,
                  currentIndex + 5
                )
                const seriesBig = seriesList[currentIndex]
                return (
                  <SwiperSlide key={index}>
                    <div
                      className="atlas"
                      key={get(seriesBig, 'series_id') || index}
                    >
                      <div className="left-section fl">
                        <SeriesDetailLink
                          id={`${seriesBig?.series_id}`}
                          onClick={() => {
                            sendTeaCommEvent(
                              'click_excellent_car_picture_card',
                              {
                                car_series_name: seriesBig?.series_name,
                                rank: index,
                                item_rank: 0,
                              }
                            )
                          }}
                        >
                          <div className="image-transition">
                            <div
                              className="big-image"
                              style={{
                                backgroundImage: `url(${applyHttpsImage(
                                  get(seriesBig, 'cover_url', '')
                                )})`,
                              }}
                            />
                            <div className="series-name">
                              {get(seriesBig, 'series_name') || ''}
                            </div>
                          </div>
                        </SeriesDetailLink>
                      </div>
                      <div className="right-section fr">
                        {currectList.map((item, index) => (
                          <div
                            className="image-wrapper"
                            key={get(item, 'series_id') || index}
                          >
                            <SeriesDetailLink
                              id={`${get(item, 'series_id', '')}`}
                              onClick={() => {
                                sendTeaCommEvent(
                                  'click_excellent_car_picture_card',
                                  {
                                    car_series_name:
                                      get(item, 'series_name') || '',
                                    rank: index,
                                    item_rank: index + 1,
                                  }
                                )
                              }}
                            >
                              <div className="image-transition">
                                <div
                                  className="small-image"
                                  style={{
                                    backgroundImage: `url(${applyHttpsImage(
                                      get(item, 'cover_url', '')
                                    )})`,
                                  }}
                                />
                                <div className="series-name">
                                  {get(item, 'series_name') || ''}
                                </div>
                              </div>
                            </SeriesDetailLink>
                          </div>
                        ))}
                      </div>
                    </div>
                  </SwiperSlide>
                )
              })}
            <div className="atlas-nav-pre swiper-nav-pre" />
            <div className="atlas-nav-next swiper-nav-next" />
            <div className="banner-swiper-pagination tw-flex" />
          </Swiper>
        </section>
        <section className="car-pano-wrapper">
          <div className="header">
            <div className="title">全景内饰</div>
          </div>
          <Link href={panoramicCar?.panoramic_url}>
            <a
              onClick={() => {
                sendTeaCommEvent('click_360_view_car_picture')
              }}
              target="_blank"
            >
              <div className="car-pano">
                <div className="image-transition">
                  <div className="car-pano-mask" />
                  <div
                    className="big-image"
                    style={{
                      backgroundImage: `url(${panoramicCar?.ns_cover_url})`,
                    }}
                  />
                </div>
                <p className="panoramic-title">
                  {panoramicCar?.series_name} - 360°全景内饰
                </p>
              </div>
            </a>
          </Link>
        </section>
      </div>
      <style jsx>
        {`
          .atlas-nav-next,
          .atlas-nav-pre {
            display: inline-block;
          }
          .card-wrapper {
            padding-top: 40px;
            display: flex;
          }
          .car-atlas {
            height: 342px;
            width: 800px;
          }
          .header {
            height: 36px;
            line-height: 36px;
            margin-bottom: 16px;
          }
          .title {
            font-size: 24px;
            font-weight: 500;
            color: #1a1a1a;
          }
          .more {
            font-size: 16px;
            color: #1a1a1a;
            text-decoration: none;
          }
          .more-icon {
            margin: -2px 0 0 4px;
          }
          .atlas {
            width: 100%;
            height: 283px;
          }
          .left-section {
            width: 380px;
            border-radius: 2px;
          }
          .right-section {
            width: 420px;
            display: flex;
            flex-wrap: wrap;
          }
          .image-transition {
            overflow: hidden;
            position: relative;
          }
          .image-transition:hover .big-image,
          .image-transition:hover .small-image {
            transform: scale(1.1);
          }
          .big-image,
          .small-image {
            background-size: cover;
            transition: transform 0.3s ease-in-out;
            border-radius: 2px;
          }
          .big-image {
            width: 380px;
            height: 260px;
          }
          .small-image {
            width: 194px;
            height: 126px;
          }
          .right-section .image-wrapper {
            margin-left: 16px;
            margin-bottom: 8px;
          }

          .series-name {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background-image: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0),
              #1f2129
            );
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
          }
          .left-section .series-name {
            height: 40px;
            font-size: 16px;
            font-weight: 500;
          }
          .right-section .series-name {
            height: 32px;
            font-weight: 14px;
          }

          :global(.car-atlas .swiper-button-prev, .car-atlas
              .swiper-button-next) {
            height: 48px;
            width: 32px;
            opacity: 1;
            background: rgba(0, 0, 0, 0.4);
            margin-top: -24px;
          }
          :global(.car-atlas .swiper-button-prev:after, .car-atlas
              .swiper-button-next:after) {
            width: 24px;
            height: 24px;
            position: absolute;
            top: 12px;
            left: 4px;
            background-image: url(${require('static/left-ic.png')});
            background-size: cover;
            margin: 0;
          }
          :global(.car-atlas .swiper-button-prev:hover, .car-atlas
              .swiper-button-next:hover) {
            background: #f5b330;
            opacity: 1;
          }
          :global(.car-atlas .swiper-button-prev:after) {
            transform: rotateZ(-180deg);
          }

          :global(.car-atlas .swiper-pagination-bullets) {
            height: 16px;
          }
          :global(.car-atlas .swiper-pagination-bullet) {
            width: 8px;
            height: 4px;
            border-radius: 0;
            background: #c9cbd6;
          }
          :global(.car-atlas .swiper-pagination-bullet-active) {
            width: 16px;
            background: #ffcd32;
          }
          .car-pano-wrapper {
            margin-left: 16px;
          }
          .car-pano {
            width: 380px;
            height: 260px;
            border-radius: 2px;
            overflow: hidden;
            position: relative;
          }
          .car-pano-mask {
            width: 380px;
            background-color: rgba(0, 0, 0, 0.08);
            z-index: 100;
            position: absolute;
            height: 260px;
          }
          .panoramic-title {
            color: white;
            font-size: 16px;
            font-weight: 500;
            position: absolute;
            width: 100%;
            text-align: center;
            bottom: 9px;
          }
          .big-image::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 40px;
            background-image: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0),
              #1f2129
            );
          }

          :global(.swiper-atlas-class .banner-swiper-pagination) {
            @apply tw-w-100 tw-absolute tw-h-4 tw-bottom-8 tw-z-1 tw-items-center tw-justify-end;
            left: 50%;
            transform: translate(-50%, 0);
          }
          :global(.swiper-atlas-class .banner-bullet) {
            @apply tw-h-4 tw-bg-white tw-mr-4 tw-cursor-pointer;
            width: 8px;
            margin: 0 4px;
            background-color: #c9cbd6;
          }
          :global(.swiper-atlas-class .banner-bullet.banner-active-bullet) {
            width: 16px;
            background-color: #ffcd32;
          }
        `}
      </style>
    </>
  )
}
